import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IAccountOrBankDetailsToolbar {
	isSubmitting: boolean;
	onResetClickHandler: () => void

}

export const AccountOrBankDetailsToolbar: FC<IAccountOrBankDetailsToolbar> = ({
	isSubmitting = false,
	onResetClickHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#fff",
				// marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				bottom: 0,
			}}
		>
			<Toolbar>
				<>
					<EnhancedButtonPrimeReact
						label="Save"
						loading={isSubmitting}
						type="submit"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/>
					<EnhancedButtonPrimeReact
						label="Clear Form"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						onClickHandler={onResetClickHandler}
						style={{ marginLeft: "1rem" }}
					/>
				</>
			</Toolbar></AppBar>
	);
};
